export default __webpack_public_path__ + "static/media/descriptionLight.a14b6b2b.svg";